import React from 'react';
import { List } from 'antd';
import { observer } from 'mobx-react';
import { CardLinkItem, CardLinkItemProps } from './CardLink';
import { MapWidgetLinkItem } from './MapWidgetLink';

export const LinkList: React.FC<CardLinkItemProps> = observer(
  function LinkList({ card }) {
    return (
      <List size="small">
        <CardLinkItem card={card} />
        <MapWidgetLinkItem card={card} />
      </List>
    );
  },
);
